export const PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED =
	'__storejs_platform_educational_discount_dismissed';
